import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AlertConfigurationComponent } from "./alert-configuration/alert-configuration.component";

const routes: Routes = [
	{
		path: "",
		component: AlertConfigurationComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class AlertConfigurationRoutingModule {}
